<template>
    <Breadcrumbs main="Ui Kits" title="Tooltip" />
    <div class="container-fluid">
        <div class="row">
            <basicTooltip />
            <coloredTooltip />
            <directionsTooltip />
            <hoverEffect />
            <filledTooltip />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'
const basicTooltip = defineAsyncComponent(() => import("@/components/theme/uikits/tooltip/basicTooltip.vue"))
const coloredTooltip = defineAsyncComponent(() => import("@/components/theme/uikits/tooltip/coloredTooltip.vue"))
const directionsTooltip = defineAsyncComponent(() => import("@/components/theme/uikits/tooltip/directionsTooltip.vue"))
const hoverEffect = defineAsyncComponent(() => import("@/components/theme/uikits/tooltip/hoverEffect.vue"))
const filledTooltip = defineAsyncComponent(() => import("@/components/theme/uikits/tooltip/filledTooltip.vue"))
</script>